/* eslint-disable camelcase */
import React, { useState } from 'react'
import { Card, CardContent, Grid, Stack } from '@mui/material'
import AdministrationAction from 'administration/actions/AdministrationAction'
import { StyledFieldSet, StyledLegend } from 'components/StyledElements'
import { useDispatch } from 'react-redux'
import i18n from 'simple-react-i18n'
import useTitle from 'utils/customHook/useTitle'
import useStateAppSetting from 'utils/customHook/useStateAppSetting'
import useActions from 'utils/customHook/useActions'
import { CardTitle } from 'components/card/NewCard'
import SimpleDatePicker from 'components/forms/SimpleDatePicker'
import moment from 'moment'

const TerritorySettingsAuthorisationCalendar = () => {
    const [readMode, setReadMode] = useState(true)

    const dispatch = useDispatch()

    const [startDateCampaign, setStartDateCampaign] = useStateAppSetting('startDateCampaign', v => v ? moment(v, 'DD/MM').valueOf() : undefined)

    const onCancel = () => {
        dispatch(AdministrationAction.fetchApplicationSettings()).then(() => {
            setReadMode(true)
        })
    }

    useTitle(() => [{
        title: i18n.steering,
        href: 'territory',
    }, {
        title: i18n.settings,
        href: 'territory/settings',
    }, {
        title: i18n.authorisationCalendar,
        href: 'territory/settings/calendar',
    }], [])

    useActions(() => {
        if (readMode) {
            return { edit: () => setReadMode(false) }
        }
        return {
            cancel: () => onCancel(),
            save: () => {
                const settings = [
                    { parameter: 'startDateCampaign', value: startDateCampaign ? moment(startDateCampaign).format('DD/MM') : undefined },
                ]
                dispatch(AdministrationAction.updateSieauParameters(settings)).then(() => {
                    dispatch(AdministrationAction.fetchApplicationSettings()).then(() => {
                        setReadMode(true)
                    })
                })
            },
        }
    }, [readMode, startDateCampaign])

    return (
        <Card>
            <CardTitle title={i18n.parameters} />
            <CardContent>
                <Stack>
                    <StyledFieldSet>
                        <StyledLegend>{i18n.campaignSettings}</StyledLegend>
                        <Grid container spacing={1}>
                            <SimpleDatePicker
                                label={i18n.startDate}
                                value={startDateCampaign}
                                onChange={setStartDateCampaign}
                                disabled={readMode}
                                views={['month', 'day']}
                                openTo='month'
                                format='DD/MM'
                                slotProps={{
                                    textField: { fullWidth: true, placeholder: 'DD/MM' },
                                    calendarHeader: { format: 'MMMM' },
                                    toolbar: { hidden: true },
                                }}
                            />
                        </Grid>
                    </StyledFieldSet>
                </Stack>
            </CardContent>
        </Card>
    )
}

export default TerritorySettingsAuthorisationCalendar